import { Container } from '@ui/container'
import clsx from 'clsx'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, { type FC, type PropsWithChildren } from 'react'

type SectionIconicProps = {
  className: string
  backgroundImage: Queries.ContentfulAvifAssetFragment
}

export const SectionIconic: FC<SectionIconicProps & PropsWithChildren> = ({
  className,
  backgroundImage,
  children,
}) => (
  <div className="relative w-full">
    <GatsbyImage
      alt={backgroundImage.description}
      className="!absolute inset-0 h-full w-full"
      image={getImage(backgroundImage)}
      objectFit="cover"
    />
    <Container
      className={clsx(
        className,
        'relative flex flex-col items-center justify-center pb-[72px] pt-[72px] laptop:pb-[120px] laptop:pt-[120px]'
      )}
    >
      {children}
    </Container>
  </div>
)
